var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificates-status-block",class:{ 'certificates-status-block_selected': _vm.isSelected },on:{"click":function($event){return _vm.$emit('select')}}},[_c('h6',[_vm._v(_vm._s(_vm.status.label))]),_c('p',[_vm._v(_vm._s(_vm.status.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }